export const dateFormat = "MMM DD YYYY hh:mm A";
export const dateFormatAltHour = "MMM DD YYYY h:mm A";
export const dateFormatNoTime = "MMM DD YYYY";
export const dateFormatSlashed = "MM/DD/YYYY";
export const dateFormatMui = "MM/dd/yyyy";
